import translations from '@/translations/translations.json'

const languages = {
  en_GB: 'EN',
  bg_BG: 'BG'
}

const translateConfig = {
  availableLanguages: languages,
  defaultLanguage: (localStorage.language &&
      languages[localStorage.language]) ? localStorage.language : 'bg_BG',
  translations: translations,
  silent: true
}

const veeValidateLangMapping = {
  en_GB: 'en',
  bg_BG: 'bg'
}

export { translateConfig, veeValidateLangMapping }
